import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAttendanceReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  const url = isAllCompanies
    ? `${Api_EndPoints.AllCompanies_GetAttendanceDetailReport}`
    : `${Api_EndPoints.AttendanceDetailReport}`;
  let queryString =
    employeeCode !== 0
      ? `FromDate=${fromDate}&ToDate=${toDate}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&Employee=${employeeCode}`
      : `FromDate=${fromDate}&ToDate=${toDate}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;

  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }
  const { data } = await http_payroll.get(`${url}?${queryString}`);
  console.log(data);
  return data;
};

export const useAttendanceReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetAttendanceDetailReport
        : Api_EndPoints.AttendanceDetailReport,
    ],
    queryFn: () => getAttendanceReport(input),
    refetchOnWindowFocus: false,
  });
};
